// import logo from './logo.svg';
import './App.css';

function App() {
  function btnSubmit(){
    if(document.getElementById("frmFileDocx").files.length === 0){
      window.alert("Please select Document file...");
      return;
    }
    // if(document.getElementById("frmFileJson").files.length === 0){
    //   window.alert("Please select JSON file...");
    //   return;
    // }
    const js_value = document.getElementById("txtJson").value;
    if(js_value.length < 1){
      window.alert("Please enter JSON values...");
      return;
    }
    try{
      JSON.parse(js_value);
    }catch(e){
      window.alert("Invalid JSON values found...")
      return;
    }
    document.getElementById("spnDownload").classList.remove("d-none")
    document.getElementById("stsText").innerText = "";
    const filedocx = document.querySelector("#frmFileDocx");
    // const filejson = document.querySelector("#frmFileJson");
    const formData = new FormData();
    formData.append("filedocx", filedocx.files[0]);
    // formData.append("filejson", filejson.files[0]);
    formData.append("jsonvalue", js_value);
    // fetch("http://localhost:5000/download",{method:"POST",body:formData})
    fetch("https://belasko.eshci.com/api/download",{method:"POST",body:formData})
    .then((respone)=> respone.blob())
    .then((blob)=>{
      const url = window.URL.createObjectURL(blob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute(
        "download",
        "progress_report.pdf"
      );
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    })
    .catch((error)=>{
      document.getElementById("stsText").innerText = "Falied to create PDF file. Please select valid input files."
    })
    .finally(()=>{document.getElementById("spnDownload").classList.add("d-none")})
  }
  return (
    <div className="App" style={{fontSize:'small'}}>
      <div className="container p-4">
      <div className="row">
        <img alt="logo" src="/logo.png" className="rounded my-3" style={{width:'100px'}}/>
          <div className="card" style={{border:'none'}}>
            <div className="card-body">
                <h6 className="card-title mb-3">Document Creation</h6>
                <div className="mb-3 px-4">
                  <label htmlFor="frmFileDocx" className="form-label">Template document:</label>
                  <input className="form-control form-control-sm" id="frmFileDocx" name="filedocx" type="file" accept=".docx,.doc,application/msword"/>
                </div>
                <div className="mb-3 px-4">
                  <label htmlFor="txtJson" className="form-label">JSON Data:</label>
                  <textarea className="form-control form-control-sm" id="txtJson" rows="6"></textarea>
                  {/* <input className="form-control form-control-sm" id="frmFileJson" name="filejson" type="file" accept=".json"/> */}
                </div>
                <p className="card-text text-end px-4 text-bold" id="stsText"></p>
                <div className="px-4">
                  <button className="btn btn-primary float-end btn-sm" onClick={btnSubmit}>
                    <div className="spinner-border spinner-border-sm d-none me-2" id="spnDownload" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Download
                  </button>
                </div>
            </div>
          </div>
          <small className="text-muted px-4">© 2024 All Rights Reserved.</small>
      </div>        
	    </div>
    </div>
  );
}

export default App;
